<template>
	<div>
		<div class="page">
			<div class="title1">修改个人信息</div>
			<div class="title2">为了保障你的账户安全，请先进行安全验证</div>
			<div class="step">
				<Steps :current="currentIndex">
					<Step title="填写登录密码" />
					<Step title="绑定新手机号" />
					<Step title="完成" />
				</Steps>
			</div>

			<Spin :spinning="loading" v-if="currentIndex == 0">
				<div class="content">
					<FormModel ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
						<Item label="手机号" prop="webTel">
							<Input autocomplete="off" v-model="form.webTel" placeholder="请输入手机号" />
						</Item>
						<Item label="密码" prop="webCode">
							<Password autocomplete="off" v-model="form.webCode" type="password" placeholder="请输入密码" />
						</Item>
					</FormModel>
					<div class="btn-list">
						<Button type="primary" @click="goBack">返回</Button>
						<Button type="primary" :style="{ marginLeft: '50px' }" @click="checkPersonMes">下一步</Button>
					</div>
				</div>
			</Spin>

			<Spin :spinning="loading" v-if="currentIndex == 1">
				<div class="content">
					<FormModel ref="ruleForm2" :model="form2" :rules="rules2" :label-col="labelCol" :wrapper-col="wrapperCol">
						<Item label="新手机号" prop="webTel">
							<Input autocomplete="off" v-model="form2.webTel" placeholder="请输入手机号" />
						</Item>
						<Item label="验证码" prop="key">
							<div class="f-r-cc">
								<Input v-model="form2.key" maxlength="6" placeholder="请输入验证码" />
								<Button type="primary" :style="{marginLeft: '10px'}" @click="getCode">获取验证码</Button>
							</div>
						</Item>
					</FormModel>
					<div class="btn-list">
						<Button type="primary" @click="goBack">返回</Button>
						<Button type="primary" :style="{ marginLeft: '50px' }" @click="changePhone">下一步</Button>
					</div>
				</div>
			</Spin>

			<div class="content" v-if="currentIndex == 2">
				<div class="tips f-r-cc">
					<Icon type="check-circle" :style="{ color: '#1F82E2' , marginRight: '10px'}" />
					<div>恭喜你，修改成功</div>
				</div>
				<div class="btn-list">
					<Button type="primary" @click="goBack">完成</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Steps, FormModel, Message } from "ant-design-vue";
const { Item } = FormModel;
const { Step } = Steps;
import { getAction, postAction } from "@/util/require.js";
export default {
	name: "",
	components: {
		Steps,
		Step,
		Item,
		FormModel,
	},
	data() {
		return {
			currentIndex: 0,
			loading: false,
			labelCol: { span: 5 },
			wrapperCol: { span: 14 },
			form: {},
			rules: {
				webTel: [
					{ required: true, message: "请输入手机号" },
					{ pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: "请输入正确格式的手机号" },
				],
				webCode: [{ required: true, message: "请输入密码" }],
			},

			form2: {},
			rules2: {
				webTel: [
					{ required: true, message: "请输入手机号" },
					{ pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: "请输入正确格式的手机号" },
				],
				key: [{ required: true, message: "请输入验证码" }],
			},
		};
	},
	created() {},
	mounted() {},
	methods: {
		goBack() {
			this.$router.replace({ path: "/person" });
		},
		checkPersonMes() {
			this.$refs.ruleForm.validate((valid, val) => {
				if (valid) {
					this.loading = true;
					getAction("/hq/webPage/checkPersonMes", { ...this.form })
						.then((res) => {
							if (res.success) {
								this.currentIndex = 1;
							} else {
								Message.warning(res.message);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		changePhone() {
			this.$refs.ruleForm2.validate((valid) => {
				if (valid) {
					this.loading = true;
					getAction("/hq/webPage/changePhone", { ...this.form2 })
						.then((res) => {
							if (res.success) {
								this.currentIndex = 2;
							}
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					return false;
				}
			});
		},
		getCode() {
			if (!this.form2.webTel) {
				Message.warning("请输入手机号");
				return;
			}
			postAction("/hq/appletsLogin/sms", { mobile: this.form2.webTel }).then((res) => {
				if (res.success) {
					Message.success("验证码已发送");
				} else {
					Message.warning("验证码发送失败");
				}
			});
		},
		// checkPersonMes
	},
};
</script>

<style scoped lang="scss">
.page {
	width: 100%;
	padding: 53px 30px 0 30px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	background: #fff;
	box-shadow: 0px 7px 24px 0px rgba(8, 124, 232, 0.15);
	border-radius: 2px;
	min-height: 800px;
}
.title1 {
	font-size: 40px;
	font-family: PingFang;
	font-weight: bold;
	color: #333333;
	line-height: 1;
}
.title2 {
	margin-top: 14px;
	font-size: 26px;
	font-family: PingFang;
	font-weight: 500;
	color: #999999;
	line-height: 1;
}
.step {
	width: 600px;
	margin-top: 71px;
}

.content {
	padding-top: 60px;
	width: 500px;
	min-height: 400px;
	.btn-list {
		margin-top: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.tips {
	font-size: 24px;
	font-family: PingFang;
	font-weight: bold;
	color: #1f82e2;
}
</style>
